export default __webpack_public_path__ + "static/edit-message-08dc3880c66eed69b4803c5fcf7576c6.png";